module.exports = __webpack_public_path__ + "static/Zbrush-3c58862e41d96ea2c0194062a6689876.png";